<template>
   <div class="invoice-list-page-container sub-page-wrapper">
      <Aside />
      <Main>
         <Navbar />

         <div class="container-fluid">
            <div class="row">
               <div class="col gts-box mx-3">
                  <h1 class="sub-page-header">{{ $t("invoiceList_title") }}</h1>

                  <div class="sub-page-row-wrapper row gy-3">
                     <div class="col-12 col-md-6 col-lg-2">
                        <UIDatePicker2 :key="$i18n.locale" :label="$t('invoiceList_filter_lblFromDate')" :min="searchQuery.date1.min" :max="searchQuery.date1.max" v-model="searchQuery.date1.value" />
                     </div>
                     <div class="col-12 col-md-6 col-lg-2">
                        <UIDatePicker2 :key="$i18n.locale" :label="$t('invoiceList_filter_lblToDate')" :min="searchQuery.date2.min" :max="searchQuery.date2.max" v-model="searchQuery.date2.value" />
                     </div>
                     <div class="col-12 col-md-6 col-lg-2">
                        <UIInput v-model="searchQuery.orderId" :placeholder="$t('invoiceList_filter_phOrderId')" :label="$t('invoiceList_filter_lblOrderId')" allow-clear />
                     </div>
                     <div class="col-12 col-md-6 col-lg-2">
                        <UIInput v-model="searchQuery.pnr" :placeholder="$t('invoiceList_filter_phPnr')" :label="$t('invoiceList_filter_lblPnr')" allow-clear />
                     </div>
                  </div>

                  <!--  CTA -->
                  <div class="sub-page-actions-row row">
                     <div class="sub-pages-actions-wrapper col-12">
                        <UIButton className="default" :text="$t('invoiceList_filter_btnList')" @click.native="listInvoices()" />
                     </div>
                  </div>
               </div>
            </div>

            <section class="page-section gts-box" v-if="currentTableOptions.rows.length > 1">
               <GtsGrid :table-options="currentTableOptions" :item-per-page="-1" :title="$t('invoiceList_title')" @setInvoiceNote="setInvoiceNote" />
            </section>
         </div>
      </Main>
   </div>
</template>

<script>
import moment from "moment";
import i18n from "@/fmt/i18n.js";
import Popup from "@/gts-popup.js";
import Main from "@/components/unitary/Main.vue";
import Aside from "@/components/unitary/Aside.vue";
import { financeService } from "@/service/index.js";
import GtsGrid from "@/components/utils/GtsGrid.vue";
import Navbar from "@/components/unitary/Navbar.vue";
import UIButton from "@/components/unitary/Button.vue";
import UIInput from "@/components/unitary/form2/UIInput.vue";
import UIDatePicker2 from "@/components/unitary/form2/UIDatePicker2.vue";

export default {
   name: "InvoiceList",
   components: {
      Main,
      Aside,
      Navbar,
      UIInput,
      GtsGrid,
      UIButton,
      UIDatePicker2,
   },
   data() {
      return {
         searchQuery: {
            date1: {
               min: moment("2021-01-01").format(this.$constants.dateFormat),
               max: moment().format(this.$constants.dateFormat),
               value: moment().format(this.$constants.dateFormat),
            },
            date2: {
               min: moment("2021-01-01").format(this.$constants.dateFormat),
               max: moment().format(this.$constants.dateFormat),
               value: moment().format(this.$constants.dateFormat),
            },
            orderId: "",
            pnr: "",
         },
         tableOptions: {
            columns: [],
            rows: [],
         },
      };
   },
   computed: {
      tableColumns() {
         return [
            { label: this.$t("invoiceList_tblMain_thInvoiceId") },
            { label: this.$t("invoiceList_tblMain_thInvoiceNumber") },
            { label: this.$t("invoiceList_tblMain_thInvoiceDate") },
            { label: this.$t("invoiceList_tblMain_thInvoiceTotal") },
            { label: this.$t("invoiceList_tblMain_thInvoiceInfo") },
            { label: this.$t("invoiceList_tblMain_thInvoiceNote") },
         ];
      },
      currentTableOptions() {
         return { ...this.tableOptions, columns: this.tableColumns };
      },
   },
   created() {
      this.$store.commit("app/setDocRequestToInitialState");
   },
   methods: {
      setInvoiceNote(obj) {
         this.$store.commit("app/setIsProgressGifActive", true);
         const query = {
            invoiceId: obj.id,
            agencyNote: obj.note,
         };
         financeService.setInvoiceNote(query).then((res) => {
            if (!res.result.success) {
               this.$store.commit("app/setIsProgressGifActive", false);
               Popup.result(res.result);
            }
            this.$store.commit("app/setIsProgressGifActive", false);
         });
      },
      listInvoices() {
         this.tableOptions.rows = [];

         this.$store.commit("app/setIsProgressGifActive", true);

         let request = {
            date1: this.searchQuery.date1.value,
            date2: this.searchQuery.date2.value,
            orderId: this.searchQuery.orderId && this.searchQuery.orderId.length > 0 ? parseInt(this.searchQuery.orderId) : -1,
            pnr: this.searchQuery.pnr && this.searchQuery.pnr.length > 0 ? this.searchQuery.pnr : null,
         };

         financeService.listInvoices(request).then((res) => {
            this.$store.commit("app/setIsProgressGifActive", false);

            if (!res.result.success) {
               res.result.service = this.$options.name;
               Popup.result(res.result);
               return;
            }
            if (res.result.success) {
               //HEADER_ROW
               this.tableOptions.rows.push({
                  invoiceId: "",
                  invoiceNumber: "",
                  invoiceDate: "",
                  invoiceTotal: {
                     iteration: [this.$options.filters.price(res.grandTotal, res.currency)],
                     className: "is-price",
                  },
                  invoiceInfo: {
                     iteration: [`${i18n.t("invoiceList_tblMain_thGrandTotal")}`],
                     className: "txt-black",
                  },
                  invoiceNote: "",
                  tags: "",
               });

               res.invoices.map((invoice) => {
                  const rowObj = {
                     invoiceId: {
                        iteration: [invoice.id],
                        icon: "invoice",
                        method: () => {
                           this.$store.state.app.documentViewer.request.documentType = 3;
                           this.$store.state.app.documentViewer.request.fileType = 2;
                           this.$store.state.app.documentViewer.request.showPrice = false;
                           this.$store.state.app.documentViewer.hasPrice = false;

                           this.$store.state.app.documentViewer.request.identifiers = [{ identifier: invoice.uuid, subIdentifiers: [] }];

                           this.$store.commit("app/setDocumentViewer", true);
                        },
                     },
                     invoiceNumber: invoice.invoiceNumber,
                     invoiceDate: this.$options.filters.FormatterDate(invoice.invoiceDate),
                     invoiceTotal: {
                        iteration: [this.$options.filters.price(invoice.totalAmount, invoice.currency)],
                        className: "is-price",
                     },
                     invoiceInfo: {
                        iteration: [invoice.description, i18n.t("invoiceList_info_" + invoice.identifier)],
                     },
                     invoiceNote: { iteration: [invoice.agencyNote == null ? "" : invoice.agencyNote], isInput: true, invoiceId: invoice.id },
                     tags: JSON.stringify(invoice),
                  };
                  this.tableOptions.rows.push(rowObj);
               });
            }
         });
      },
   },
   watch: {
      "searchQuery.date1.value"(newDate1) {
         const maxDate2 = moment(newDate1).add(1, "year").format(this.$constants.dateFormat);
         if (moment(this.searchQuery.date2.value).isAfter(maxDate2)) {
            this.searchQuery.date2.value = maxDate2;
         }
         if (moment(newDate1).isAfter(this.searchQuery.date2.value)) {
            this.searchQuery.date2.value = newDate1;
         }
      },
      "searchQuery.date2.value"(newDate2) {
         const minDate1 = moment(newDate2).subtract(1, "year").format(this.$constants.dateFormat);
         if (moment(this.searchQuery.date1.value).isBefore(minDate1)) {
            this.searchQuery.date1.value = minDate1;
         }
         if (moment(newDate2).isBefore(this.searchQuery.date1.value)) {
            this.searchQuery.date1.value = newDate2;
         }
      },
   },
};
</script>

<style lang="scss" scoped>
.page-container {
   .page-inner {
      width: 90%;
      margin: auto;
      .page-form-row {
         display: grid;
         grid-template-columns: repeat(6, 1fr);
         grid-column-gap: 1rem;
      }
      .page-action-row {
         margin-top: 1rem;
         display: flex;
         justify-content: flex-end;
      }
   }
}
</style>

<style lang="scss">
#fixedFooter {
   position: inherit !important;
}
</style>
